import './App.css';

// @ts-expect-error JS file - Vite handles this dynamic import of a JS file into a TS file.
import Header from '@/components/Header/Header';
// @ts-expect-error JS file - Vite handles this dynamic import of a JS file into a TS file.
import NeedHelp from '@/components/NeedHelp';

import Header2 from '@/components/Header2/Header2';
import 'monday-ui-react-core/dist/main.css';
import { Outlet } from 'react-router-dom';
import HeaderContainer from './components/Header/HeaderContainer';
import {
  MondayStorageKeys,
  useGetFromMondayStorageQuery,
} from './hooks/api/useGetFromMondayStorageQuery';
import { useGetSessionToken } from './hooks/api/useGetSessionToken';
import { isNewOnboardingFlow } from './utils/common';
import { identifyClarityUser } from './utils/clarity.utils';

function App() {
  const { data: workflow, isLoading: isGetWorkflowLoading } =
    useGetFromMondayStorageQuery(MondayStorageKeys.WORKFLOW_TYPE);
  const { isLoading: isGetSessionTokenLoading, data } = useGetSessionToken({
    onSuccess: (data) => {
      identifyClarityUser(data.dat.account_id);
    },
  });

  const isLoading = isGetWorkflowLoading || isGetSessionTokenLoading;
  if (isLoading) {
    return (
      <div className="flex h-screen flex-col overflow-auto dark:text-white">
        <HeaderContainer>
          <></>
        </HeaderContainer>
      </div>
    );
  }

  const isNewOnboarding = isNewOnboardingFlow(workflow, data?.dat?.account_id);

  if (isNewOnboarding) {
    return (
      <div className="flex h-screen flex-col overflow-auto text-primary-neutral">
        <Header2 />
        <Outlet />
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col overflow-auto dark:text-white">
      <Header />
      <Outlet />
      <NeedHelp />
    </div>
  );
}

export default App;
